import { NotificationCategory, NotificationCategoryItem } from '@admin/notifications/notifications.service';
import { Component, input, output } from '@angular/core';

@Component({
  selector: 'irb-categories',
  templateUrl: './irb-categories.component.html',
  styleUrls: [
    './irb-categories.component.scss',
    '../../../shared/styles/grid.scss',
  ],
  standalone: false,
})
export class IrbCategoriesComponent {
  readonly irbCategories = input<NotificationCategory[]>([]);
  readonly categorySelected = output<NotificationCategoryItem | null>();
  selected!: string;

  selectItem(item: NotificationCategoryItem) {
    if (item.id === this.selected) {
      this.selected = '';
      this.categorySelected.emit(null);
      return;
    }
    this.selected = item.id;
    this.categorySelected.emit(item);
  }

  isSelected(categoryID: string) {
    return this.selected === categoryID
      ? 'category-item category-item-selected'
      : 'category-item';
  }
}
